import { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Read-only map of a flight's stored ADS-B path. Green line, blue start dot, red end dot.
export function FlightTrackMap({ track, className }: { track: [number, number][]; className?: string }) {
  const el = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!el.current || !track || track.length < 2) return;
    const map = L.map(el.current, { zoomControl: false, attributionControl: false, scrollWheelZoom: false });
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18 }).addTo(map);
    const line = L.polyline(track, { color: '#1f7a3d', weight: 3, opacity: 0.9 }).addTo(map);
    L.circleMarker(track[0], { radius: 5, color: '#fff', weight: 2, fillColor: '#1f3a6e', fillOpacity: 1 }).addTo(map);
    L.circleMarker(track[track.length - 1], { radius: 5, color: '#fff', weight: 2, fillColor: '#b42318', fillOpacity: 1 }).addTo(map);
    map.fitBounds(line.getBounds(), { padding: [18, 18] });
    // Leaflet needs a size recalc when it mounts inside a just-shown container.
    setTimeout(() => map.invalidateSize(), 60);
    return () => {
      map.remove();
    };
  }, [track]);

  return <div ref={el} className={className ?? 'h-44 w-full overflow-hidden rounded-xl border border-slate-200'} />;
}
